import { css } from "styled-components";
import { focusOutline } from "./focus";

// A row that acts on click: a service in a parcel's menu, a date preset, a
// menu item, a guide step, an autocomplete option. It is a list row, not a
// button, so it takes nothing from the kit Button: full width, left-aligned
// text, a quiet tint on hover and on the selected row.
export interface MenuRowProps {
  $selected?: boolean;
}

export const menuRow = css<MenuRowProps>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 12px;
  border-radius: 2px;
  text-align: left;
  color: ${({ theme }) => theme.textMain};
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.primary10 : "transparent"};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ $selected, theme }) =>
      $selected ? theme.primary10 : theme.subtleHover};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: transparent;
  }

  ${focusOutline}
`;
